module.exports = require('../../lib/util/main');
